export default "__VITE_ASSET__Cs5Tf3Nr__"